import React, { Linking, useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { LightenDarkenColor } from 'lighten-darken-color';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  GenderEnum,
  getLastPage,
  getNextPageByGender,
  getPageColor,
  getProgressAmount,
  getQuestionsByType,
  getQuestionTypeName,
  getResponsesByPage,
  QuestionAnswerType,
  QuestionType,
  QuestionTypeMap,
} from '../../../services/prescription';
import WhiteButton from '../../../components/WhiteButton/WhiteButton';
import { AuthActions, ChatMessageActions, EvolutionActions, PrescriptionActions, TransactionActions, UserActions } from '../../../redux/actions';
import * as UtilsActions from '../../../redux/actions/utils';
import IcNext from '../../../assets/svg/ic_next_medical.svg';
import IcBack from '../../../assets/svg/ic_back_medical.svg';
import * as QuizActions from '../../../redux/actions/quiz';
import * as MedicalAppointmentActions from '../../../redux/actions/medical-appointment';
import AuthService from '../../../services/auth';
import { translate } from '../../../services/i18n';
import { message } from 'antd';
import sadFace from '../../../assets/hair-loss/sad-face.png';
import whatsApp from '../../../assets/jpg/whatsapp.png';
import IcAttention from '../../../assets/svg/ic_atention.svg';
import { compressImages } from '../../../utils/imageUtils';
import goBack from '../../../assets/medical/go-back.svg';
import Modal from '../../../components/Modal/Modal';
import { useBeforeunload } from 'react-beforeunload';
import { get, set } from '../../../services/storage';
import { I18n } from 'react-redux-i18n';
import { EvaluationQuestions, HaveAttentionFollowConsultation, HaveNitrateMedication } from '../../../utils/localStorageVariables';
import { MedicalAppointmentMessage, MedicalAppointmentStatus, MedicalAppointmentType } from '../../../enum/medicalAppointment';
import { AlertCard } from '../../../components/AlertCard/AlertCard';
import { setDataLayer } from '../../../services/analytics';
import { updateKeysObject } from '../../../utils/updateKeysObject';
import defaultBase64 from './../../../utils/defaultBase64';
import { rgMask } from '../../../utils/masks';
import AdvancedInput from '../../../components/AdvancedInput/AdvancedInput';
import AdvancedButton from '../../../components/AdvancedButton/AdvancedButton';
import { removeSpecialChars } from '../../../utils/string';
import { Row } from 'react-bootstrap';
import weightLossFront from '../../../assets/weight-loss/body-front.png';
import weightLossRightSide from '../../../assets/weight-loss/body-side.png';
import hairLossUp from '../../../assets/hair-loss/up.png';
import hairLossFront from '../../../assets/hair-loss/front.png';
import hairLossBack from '../../../assets/hair-loss/back.png';
import melatoninaSelfie from '../../../assets/jpg/selfies.svg';
import PhotoUploader from '../../../components/PhotoUploader/PhotoUploader';
import { useDebounce } from '../../../hook/useDebounce';

const PrescriptionStep = ({
  page,
  type,
  me,
  getMe,
  quizUserResponse,
  setQuizUserResponse,
  updateUser,
  saveImageBase64,
  getUserPrescriptionByType,
  createQuiz,
  setPrescriptionFeedback,
  uploadImageBase64,
  setQuizUserPayload,
  createEvolution,
  base64,
}) => {
  const [ selectedAnswers, setSelectedAnswers ] = useState(
    getResponsesByPage(page, type, quizUserResponse),
  );

  const history = useHistory();
  const { setDebounce } = useDebounce(7000);
  const isHaveEvaluationQuestions = localStorage.getItem(EvaluationQuestions) ? JSON.parse(localStorage.getItem(EvaluationQuestions)) : [];
  const isHaveNitrate = localStorage.getItem(HaveNitrateMedication) ? JSON.parse(localStorage.getItem(HaveNitrateMedication)) : false;
  const isHaveAttentionFollowConsultation = localStorage.getItem(HaveAttentionFollowConsultation) ? JSON.parse(localStorage.getItem(HaveAttentionFollowConsultation)) : false;
  const { pathname } = useLocation();
  const [ isMounted, setIsMounted ] = useState(false);
  const [ attentionFollowConsultation, setAttentionFollowConsultation ] = useState(false);
  const [ gender, setGender ] = useState(get('gender'));
  const [ endQuestionary, setEndQuestionary ] = useState(false);
  const [ endWhatsApp, setEndWhatsApp ] = useState(false);
  const [ isModalOpen, setIsModalOpen ] = useState(false);
  const [ userNationalityDocument, setUserNationalityDocument ] = useState('');
  const [ endQuestionaryModal, setEndQuestionaryModal ] = useState(false);
  const [ isSingleSelected, setIsSingleSelected ] = useState(false);
  const [ userPrescription, setUserPrescription ] = useState([]);
  const [ createdEvolution, setCreatedEvolution ] = useState('');
  const [ responseEvolution, setResponseEvolution ] = useState('');
  const [ showIMCLowAlert, setShowIMCLowAlert ] = useState(false);
  const [ isSubmitting, setIsSubmitting ] = useState(false);

  const isLastPage = getLastPage(type);

  const uploadConfigs = {
    [QuestionType.HAIR_LOSS]: [
      { label: 'Parte de cima da cabeça', key: 'filePicTop' },
      { label: 'Parte da frente', key: 'filePicFront' },
      { label: 'Parte de trás da cabeça', key: 'filePicBack' },
    ],
    [QuestionType.WL]: [
      { label: 'Corpo de frente', key: 'filePicFront' },
      { label: 'Corpo de lado', key: 'filePicRightSide' },
    ],
    [QuestionType.MELATONINA]: [
      { label: 'Selfie', key: 'filePicFront' },
    ],
  };

  const iFileLists = {
    [QuestionType.HAIR_LOSS]: [
      [ { uid: '-1', name: 'default1.png', status: 'done', url: hairLossUp } ],
      [ { uid: '-1', name: 'default1.png', status: 'done', url: hairLossFront } ],
      [ { uid: '-1', name: 'default1.png', status: 'done', url: hairLossBack } ],
    ],
    [QuestionType.WL]: [
      [ { uid: '-1', name: 'default1.png', status: 'done', url: weightLossFront } ],
      [ { uid: '-1', name: 'default1.png', status: 'done', url: weightLossRightSide } ],
    ],
    [QuestionType.MELATONINA]: [
      [ { uid: '-1', name: 'default1.png', status: 'done', url: melatoninaSelfie } ],
    ],
  };

  const [ fileLists, setFileLists ] = useState(iFileLists[type]);

  const handleFilesChange = (fileListsUpdated) => {
    setFileLists(fileListsUpdated);
  };

  const calculateIMC = () => {
    if (type === QuestionType.WL) {
      const weightQuestion = selectedAnswers.find(q => q.id === 4);
      const heightQuestion = selectedAnswers.find(q => q.id === 6);

      const weight = parseFloat(weightQuestion?.answers[0]?.userAnswer || 0);
      const height = parseFloat(heightQuestion?.answers[0]?.userAnswer || 0) / 100;

      return height > 0 ? weight / (height * height) : 0;
    }
  };

  useEffect(() => {
    const imc = calculateIMC();
    setShowIMCLowAlert(imc < 25 && imc > 0);
  }, [ selectedAnswers ]);

  useBeforeunload((event) => {
    set('redirectToInitialForm', true);
  });

  const ref = useRef(null);

  const handleClick = () => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const onUpdateUser = async (e) => {
    if (e) e.preventDefault();

    if (removeSpecialChars(userNationalityDocument).length < 6) {
      return message.error('RG inválido');
    }

    await updateUser(me && me.id, {
      nationalityDocument: removeSpecialChars(userNationalityDocument),
    }, async (response) => {
      if (response) {
        await getMe();
        message.success('Usuário atualizado com sucesso.');
        setIsModalOpen(false);
      }
    });
  };

  const getUserPrescription = async () => {
    const response = await getUserPrescriptionByType(type);
    setUserPrescription(response);
    return response;
  };

  useEffect(() => {
    async function getUser () {
      if (AuthService.isAuthenticated()) {
        await getMe();
      }

      setIsMounted(true);
    }

    getUser();
  }, []);

  useEffect(() => {
    if (!me && isMounted) {
      // eslint-disable-next-line no-useless-escape
      const regex = /\/questionario\/([^\/]+)\/passo-1/;
      const match1 = pathname.match(regex);

      history.push(`/?type=${match1[1]}`);
    }
  }, [ me, isMounted ]);

  useEffect(() => {
    if (!me?.nationalityDocument && (type === QuestionType.EJ || type === QuestionType.WL)) {
      setIsModalOpen(true);
    }
  }, [ me ]);

  useEffect(() => {
    if (isHaveAttentionFollowConsultation) {
      setAttentionFollowConsultation(true);
    }

    setGender(get('gender'));
  }, []);

  useEffect(() => {
    AuthService.isFromPrescriptionDomain();
    hideQuestions(getResponsesByPage(page, type, quizUserResponse), true);
  }, [ pathname ]);

  const setAttentionLocalStorage = (value) => {
    set(HaveAttentionFollowConsultation, value);

    if (value) message.error(I18n.t('COMPONENTS.PRESCRIPTION.FOLLOW_CONSULTATION'));
  };

  const sentEndQuiz = (value) => {
    setEndQuestionary(
      value === 'Não me recordo de ter tido uma discussão com meu médico' &&
      (type === QuestionType.ED || type === QuestionType.BE)
    );

    setEndWhatsApp(
      value === 'Mulher' &&
      (type === QuestionType.ED || type === QuestionType.EJ)
    );
  };

  const setGenderLocal = (value) => {
    if (value === 'Mulher' || value === 'Homem') {
      set('gender', value === 'Homem' ? GenderEnum.MALE : GenderEnum.FEMALE);
    }
  };

  const answerQuestion = (questionIndex, answerIndex, value, answer) => {
    const questionsCopy = Object.assign([],
      [ ...selectedAnswers.filter((o) => o.page === page && o.type === type) ]
    );

    const answerIndexQuestion = questionsCopy[ questionIndex ].answers[ answerIndex ];

    if (answer && answer.attentionQuestion) setAttentionLocalStorage(value === I18n.t('NO'));

    sentEndQuiz(value);
    setGenderLocal(value);

    let update = true;

    questionsCopy[ questionIndex ].answers.forEach((o, i) => {
      if (o.singleSelect && o.userAnswer) {
        update = false;
      }
    });

    questionsCopy[ questionIndex ].answers.forEach((o, i) => {
      if (
        !update &&
        !answerIndexQuestion.singleSelect
      ) {
        return null;
      }

      if (
        answerIndexQuestion.type ===
        QuestionAnswerType.MULTIPLE_CHOICE &&
        answerIndexQuestion.removeAll
      ) {
        delete questionsCopy[ questionIndex ].answers[ i ].userAnswer;
      } else if (
        answerIndexQuestion.type ===
        QuestionAnswerType.MULTIPLE_CHOICE &&
        !answerIndexQuestion.removeAll
      ) {
        if (questionsCopy[ questionIndex ].answers[ i ].removeAll) {
          delete questionsCopy[ questionIndex ].answers[ i ].userAnswer;
        }
      } else if (
        !questionsCopy[ questionIndex ].answers[ i ].keep &&
        !answerIndexQuestion.keepParent &&
        !answerIndexQuestion.type !==
        QuestionAnswerType.MULTIPLE_CHOICE
      ) {
        delete questionsCopy[ questionIndex ].answers[ i ].userAnswer;
      }
    });

    if (
      answerIndexQuestion.type ===
      QuestionAnswerType.MULTIPLE_CHOICE &&
      (update || answerIndexQuestion.singleSelect)
    ) {
      if (answerIndexQuestion.userAnswer) {
        delete answerIndexQuestion.userAnswer;
      } else {
        answerIndexQuestion.userAnswer = value;
      }
    } else if (
      update ||
      answerIndexQuestion.singleSelect
    ) {
      answerIndexQuestion.userAnswer = value;
    }

    if (answerIndexQuestion.singleSelect) {
      setIsSingleSelected(true);
      questionsCopy[ questionIndex ].answers.forEach((o, i) => {
        if (i !== answerIndex) {
          delete questionsCopy[ questionIndex ].answers[ i ].userAnswer;
        }
      });
    } else {
      const singleSelect = questionsCopy[ questionIndex ].answers.find(res => res.singleSelect);

      if (singleSelect && isSingleSelected) {
        delete singleSelect.userAnswer;
        answerIndexQuestion.userAnswer = value;
        setIsSingleSelected(false);
      }
    }

    hideQuestions(questionsCopy);
  };

  const isSelectedAnswer = (questionIndex, answerIndex) => {
    return (
      selectedAnswers &&
      selectedAnswers.length > 0 &&
      selectedAnswers[ questionIndex ].answers[ answerIndex ].userAnswer
    );
  };

  const hideQuestions = (questions, notUpdate) => {
    const questionsCopy = [ ...questions ];

    questionsCopy.forEach((question, questionIndex) => {
      question.answers.forEach((answer, answerIndex) => {
        questionsCopy[ questionIndex ].answers[ answerIndex ].hidden =
          !isAllowedToAnswer(answer, questionIndex, questionsCopy);
      });
      questionsCopy[ questionIndex ].hidden = !isAllowedQuestion(questionIndex);
    });

    questionsCopy.forEach((question, questionIndex) => {
      question.answers.forEach((answer, answerIndex) => {
        if (
          questionsCopy[ questionIndex ].hidden ||
          questionsCopy[ questionIndex ].answers[ answerIndex ].hidden
        ) {
          delete questionsCopy[ questionIndex ].answers[ answerIndex ].userAnswer;
        }
      });
    });

    setSelectedAnswers(questionsCopy);

    if (!notUpdate) {
      updateUserAnswers(questionsCopy);
    }
  };

  const updateUserAnswers = (questionsCopy) => {
    const allQuestions = getQuestionsByType(type);
    const allQuestionsCopy = [ ...allQuestions ];

    allQuestionsCopy.forEach((allQuestion, allQuestionIndex) => {
      questionsCopy.forEach((question) => {
        if (
          question.page === allQuestion.page &&
          question.id === allQuestion.id
        ) {
          allQuestion.answers.forEach((allAnswer, allAnswerIndex) => {
            question.answers.forEach((answer) => {
              if (answer.id === allAnswer.id) {
                if (answer.userAnswer) {
                  allQuestionsCopy[ allQuestionIndex ].answers[
                    allAnswerIndex
                  ].userAnswer = answer.userAnswer;
                }
              }
            });
          });
        }
      });
    });
    setQuizUserResponse(allQuestionsCopy);
  };

  const isAllowedToAnswer = (answer, questionIndex, questions) => {
    let response = false;

    if (answer.selectionNeeded && answer.selectionNeeded.length > 0) {
      const hasAnswer =
        questions[ questionIndex ] &&
        questions[ questionIndex ].answers.find((o) => !!o.userAnswer);

      if (hasAnswer) {
        response = answer.selectionNeeded.indexOf(hasAnswer.id) >= 0;
      }
    } else if (answer.questionSelectionNeeded) {
      if (answer.questionSelectionNeeded.length !== undefined) {
        answer.questionSelectionNeeded.forEach((item) => {
          const question = questions.find((o) => o.id === item.id);

          question?.answers?.forEach((a) => {
            if (a.userAnswer === item.value) {
              response = true;
            }
          });
        });
      } else {
        const question = questions.find(
          (o) => o.id === answer.questionSelectionNeeded.id,
        );

        question?.answers?.forEach((a) => {
          if (a.userAnswer === answer.questionSelectionNeeded.value) {
            response = true;
          }
        });
      }
    } else if (answer.hideQuestion) {
      const question = questions.find((o) => o.id === answer.hideQuestion.id);

      question?.answers?.forEach((a) => {
        if (a.userAnswer !== answer.hideQuestion.value) {
          response = true;
        } else {
          response = false;
        }
      });
    } else {
      response = true;
    }

    return response;
  };

  const uploadImages = async () => {
    const config = uploadConfigs[type] || [];
    const bucketKeys = config.map(item => item.key);

    const imageUrls = fileLists?.flatMap(fileList => fileList.map(item => ({
      thumbUrl: item.thumbUrl,
      id: item.uid,
    }))) || [];

    if (!imageUrls.length) {
      const photo = await uploadImageBase64(defaultBase64);
      return {
        filePicTop: photo?.bucket,
        filePicFront: photo?.bucket,
        filePicBack: photo?.bucket,
        filePicRightSide: photo?.bucket,
      };

    }

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const uploadPromises = imageUrls?.map(async (imageObj) => {
      const photo = await uploadImageBase64(imageObj.thumbUrl);
      await delay(500);
      return photo?.bucket;
    });

    const results = await Promise.all(uploadPromises);

    return updateKeysObject(results, bucketKeys);
  };

  const onSubmit = async () => {
    setIsSubmitting(true);

    try {
      if (!verifyAnsweredAll()) {
        setIsSubmitting(false);
        return false;
      }

      if (type === QuestionType.WL) {
        const pregnantQuestion = quizUserResponse.find(question => question.id === 2 && question.type === QuestionType.WL);

        if (pregnantQuestion) {
          const pregnantAnswer = pregnantQuestion.answers.find(answer => answer.userAnswer === 'Sim');

          if (pregnantAnswer) {
            setIsSubmitting(false);
            message.error(translate('ERRORS.pregnantAnswerYes'));
            return false;
          }
        }
      }

      if (type === QuestionType.WL && page === 9) {
        const conditionsQuestion = quizUserResponse.find(question => question.id === 12 && question.type === QuestionType.WL);

        if (conditionsQuestion) {
          const conditionsAnswer = conditionsQuestion.answers.find(answer => answer.userAnswer === 'Nenhuma das anteriores');

          if (!conditionsAnswer) {
            setIsSubmitting(false);
            message.error(translate('ERRORS.conditionsAnswer'));
            return false;
          }
        }
      }

      if (page === isLastPage && (isHaveAttentionFollowConsultation || isHaveNitrate)) {
        const filteredQuestions = quizUserResponse.filter(response => !response.hidden);
        const availableQuestions = filteredQuestions.map(question => question.answers.map(o => ({
          ...o,
          questionId: question.id,
        })).filter(o => !o.hidden));
        const answered = availableQuestions.map(answers => answers
          .filter(answer => answer.userAnswer))
          .filter(userAnswer => userAnswer && userAnswer.length > 0);
        const response = [];

        answered.forEach(question => {
          question.forEach(answer => {
            response.push({
              question: answer.questionId,
              type: answer.type,
              answer: answer.id,
              textResponse: answer.userAnswer,
              score: 0,
            });
          });
        });

        const payload = {
          quiz: {
            quizMessage: isHaveAttentionFollowConsultation ? MedicalAppointmentMessage.SIDE_EFFECT : MedicalAppointmentMessage.NITRATE,
            questionAndResponse: response,
            type,
          },
          medicalAppointment: {
            evolutionId: null,
            attendBy: '',
            status: MedicalAppointmentStatus.PENDING_PATIENT,
            request: moment().format(),
            typeAttendance: MedicalAppointmentType.COMMON,
          }
        };

        await createQuiz(payload);

        setIsSubmitting(false);
        return history.push(I18n.t('PAGES.PROFILE.PROFILE_CHAT.URL'));
      }

      if (endQuestionary) {
        setIsSubmitting(false);
        return setEndQuestionaryModal(true);
      }

      if (page !== isLastPage) {
        setIsSubmitting(false);
        const nextPage = type === QuestionType.HAIR_LOSS ? getNextPageByGender(page, type, gender) : page + 1;
        history.push(`/questionario/${getQuestionTypeName(type).toLowerCase()}/passo-${nextPage}`);
      } else if (page === isLastPage) {
        if (type === QuestionType.HAIR_LOSS || type === QuestionType.WL || type === QuestionType.MELATONINA) {
          if (fileLists.some(fileList => fileList[0].name === 'default1.png')) {
            setIsSubmitting(false);
            return message.error('Por favor tire as fotos para a validação médica');
          } else {
            await saveImageBase64(fileLists);
          }
        }

        mappedQuestionsAndAnswers();

        uploadImages().then((images) => {
          if (images && Object.keys(images).length > 0) {
            setCreatedEvolution(images);
          }
        });
      }
    } catch (error) {
      setIsSubmitting(false);
      message.error(translate('ERRORS.INVALID_EVALUATION'));
    }
  };

  const mappedQuestionsAndAnswers = () => {
    const filteredQuestions = quizUserResponse?.filter(response => !response.hidden);

    const availableQuestions = filteredQuestions?.map(question =>
      question?.answers
        ?.filter(answer => !answer.hidden)
        ?.map(answer => ({
          ...answer,
          questionId: question.id
        }))
    );

    const response = availableQuestions?.reduce((acc, question) => {
      const filteredAnswers = question?.filter(answer => answer?.userAnswer);
      const mappedAnswers = filteredAnswers?.map(answer => ({
        question: answer?.questionId,
        type: answer?.type,
        answer: answer?.id,
        textResponse: answer?.userAnswer,
        score: 0,
      }));

      return acc.concat(mappedAnswers || []);
    }, []);

    return response;
  };

  useEffect(() => {
    handleCreateEvolution();

  }, [ createdEvolution ]);

  useEffect(() => {
    const response = mappedQuestionsAndAnswers();

    if (response && responseEvolution?.id) {
      handleCreateQuiz(response);
    }

  }, [ responseEvolution ]);

  const handleCreateEvolution = async () => {
    if (createdEvolution !== '' && typeof createEvolution !== undefined) {
      const response = await createEvolution(createdEvolution);
      setResponseEvolution(response);
    }
  };

  const handleCreateQuiz = async (response) => {
    try {
      const payload = {
        quiz: {
          questionAndResponse: response || [],
          type,
        },
        medicalAppointment: {
          evolutionId: responseEvolution?.id,
          attendBy: '',
          status: MedicalAppointmentStatus.PENDING_CONSULTATION,
          request: moment().format(),
          typeAttendance: MedicalAppointmentType.COMMON,
        }
      };

      setDataLayer('medical_evaluation_ended');
      setQuizUserPayload(payload);

      setQuizUserPayload(null);
      setQuizUserResponse(null);

      const result = await createQuiz(payload);

      if (result && result.quizUser && result.quizUser.length > 0 || result?.error === 'quiz_already_exists') {
        setQuizUserPayload(null);
        setQuizUserResponse(null);
        setPrescriptionFeedback(result.type);
      }

      const typePath = QuestionTypeMap.get(type);
      history.push(typePath ? `/questionario/${typePath}/pagamento` : '/questionario/feedback');

      setPrescriptionFeedback(type);
    } catch (error) {
      message.error(translate('ERRORS.QUIZ_ERROR'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const onChange = async (e, setFunction) => {
    const { file } = e;

    if (file) {
      file.extension =
        file.name &&
        file.name.split('.') &&
        file.name.split('.').pop().toLowerCase();
      const isJpgOrPng =
        file.extension === 'jpeg' ||
        file.extension === 'png' ||
        file.extension === 'jpg';

      if (!isJpgOrPng) {
        return message.error(translate('SHARED.fileValidation'));
      }

      file.thumbUrl = await compressImages([ file ]);

      const newFileList = [];
      newFileList[ 0 ] = {
        ...file,
        thumbUrl: file.thumbUrl,
        status: 'done',
      };

      setFunction(newFileList);
    } else {
      return message.error(translate('SHARED.fileValidation'));
    }
  };

  const verifyAnsweredAll = () => {
    let error = null;

    const questionsCopy = [ ...selectedAnswers ];

    const filteredQuestions = questionsCopy.filter((o) => !o.hidden);

    if (filteredQuestions && filteredQuestions.length > 0) {
      const availableQuestions = filteredQuestions.map((question) =>
        question.answers.filter((o) => !o.hidden),
      );

      if (type === QuestionType.ED) {
        const questionAlreadyExists = isHaveEvaluationQuestions.find((question) => question.id === filteredQuestions[ 0 ].id);
        let updatedQuestions = [];

        if (questionAlreadyExists) {
          const removeRepeated = isHaveEvaluationQuestions.filter((question) => question.id !== filteredQuestions[ 0 ].id);
          updatedQuestions = [ ...removeRepeated, ...filteredQuestions ];
        } else {
          updatedQuestions = [ ...isHaveEvaluationQuestions, ...filteredQuestions ];
        }

        localStorage.setItem(EvaluationQuestions, JSON.stringify(updatedQuestions));
      }

      if (type === QuestionType.BE) {
        const questionAlreadyExists = isHaveEvaluationQuestions.find(
          (question) => question.id === filteredQuestions[ 0 ].id
        );
        let updatedQuestions = [];

        if (questionAlreadyExists) {
          const removeRepeated = isHaveEvaluationQuestions.filter(
            (question) => question.id !== filteredQuestions[ 0 ].id
          );
          updatedQuestions = [ ...removeRepeated, ...filteredQuestions ];
        } else {
          updatedQuestions = [
            ...isHaveEvaluationQuestions,
            ...filteredQuestions,
          ];
        }

        localStorage.setItem(
          EvaluationQuestions,
          JSON.stringify(updatedQuestions)
        );
      }

      if (filteredQuestions[ 2 ] && filteredQuestions[ 2 ].id === 202) {
        const answers = filteredQuestions[ 2 ].answers.map(item => item);

        if (answers.length && answers[ 0 ].userAnswer) {
          localStorage.setItem(HaveNitrateMedication, true);
        } else {
          localStorage.setItem(HaveNitrateMedication, false);
        }
      } else {
        localStorage.setItem(HaveNitrateMedication, false);
      }

      if (availableQuestions && availableQuestions.length > 0) {
        availableQuestions.forEach((answers) => {
          const singleAnswers = answers.filter(
            (o) => o.type === QuestionAnswerType.SINGLE_CHOICE,
          );
          const multipleAnswers = answers.filter(
            (o) => o.type === QuestionAnswerType.MULTIPLE_CHOICE,
          );
          const openTextAnswers = answers.filter(
            (o) => o.type === QuestionAnswerType.OPEN_TEXT,
          );

          if (singleAnswers.length > 0) {
            const answered = singleAnswers.filter((o) => o.userAnswer);

            if (answered.length > 0) {
              if (
                openTextAnswers.length > 0 &&
                openTextAnswers.filter((o) => o.userAnswer).length === 0
              ) {
                error = 'Responda todos os campos solicitados.';
              }
            } else {
              error = 'Responda todos os campos solicitados.';
            }
          }

          if (multipleAnswers.length > 0) {
            const answered = multipleAnswers.filter((o) => o.userAnswer);

            if (answered.length > 0) {
              if (
                openTextAnswers.length > 0 &&
                openTextAnswers.filter((o) => o.userAnswer).length === 0
              ) {
                error = 'Responda todos os campos solicitados.';
              }
            } else {
              error = 'Responda todos os campos solicitados.';
            }
          }

          if (singleAnswers.length === 0 && multipleAnswers.length === 0) {
            const answered = openTextAnswers.filter((o) => !o.userAnswer);

            if (answered.length > 0) {
              error = 'Responda todos os campos solicitados.';
            }
          }
        });
      }
    }

    if (error) {
      message.error(error);
      return false;
    }

    return true;
  };

  const isAllowedQuestion = (questionIndex) => {
    const questionsCopy = [ ...selectedAnswers ];

    if (questionsCopy && questionsCopy.length > 0) {
      const response = questionsCopy[ questionIndex ].answers.map((answer) =>
        isAllowedToAnswer(answer, questionIndex, questionsCopy),
      );
      return response.filter((o) => !!o).length > 0;
    }

    return false;
  };

  const goToInitalStep = () => {
    if (
      window.confirm(
        'Deseja ir para o inicio da avaliação? Isto fará com que as respostas até agora sejam reiniciadas.',
      )
    ) {
      history.push('/');
    }
  };

  return (
    <div className="prescription-step">
      <div
        className="prescription-step__top-bar"
        style={{ backgroundColor: getPageColor(page, type) }}
      >
        <div
          className="prescription-step__top-bar__go-back"
          onClick={() => goToInitalStep()}
        >
          <img
            src={goBack}
            alt="go back"
            className="prescription-step__top-bar__go-back__img"
          />
        </div>
        <div className="prescription-step__top-bar__fix-style" />
        <div
          className="prescription-step__top-bar__text"
          onClick={() => goToInitalStep()}
        >
          {type === QuestionType.MELATONINA && 'Saúde do sono'}
          {type === QuestionType.ED && 'Saúde sexual - Ereção'}
          {type === QuestionType.BE && 'Saúde sexual - Bem Estar'}
          {type === QuestionType.EJ && 'Saúde sexual - Ejaculação'}
          {type === QuestionType.HAIR_LOSS && 'Saúde capilar'}
          {type === QuestionType.WL && 'Saúde nutricional'}
        </div>
      </div>
      <>
        {endQuestionaryModal && (
          <div className="prescription-step__end">
            <img
              className="prescription-step__end__img"
              src={sadFace}
              alt="sad Face"
            />
            <p className="prescription-step__end__text">
              Será necessário você ir até uma farmácia ou à um médico que aufira
              (meça) sua pressão para darmos continuidade ao tratamento.
            </p>
            <a className="prescription-step__end__link"
              href="/">
              Voltar para home
            </a>
            <div className="prescription-step__end__footer">
              <button
                className="prescription-step__footer__button prescription-step__footer__button--back"
                type="button"
                onClick={() => history.goBack()}
              >
                <span className="prescription-step__footer__button__icon">
                  <img
                    className="prescription-step__footer__button__icon__img prescription-step__footer__button__icon__img--back"
                    src={IcBack}
                    alt=""
                  />
                </span>
              </button>

              <button
                className="prescription-step__footer__button prescription-step__footer__button--disabled"
                type="button"
              >
                <span className="prescription-step__footer__button__icon">
                  <img
                    className="prescription-step__footer__button__icon__img"
                    src={IcNext}
                    alt=""
                  />
                </span>
              </button>
            </div>
          </div>
        )}
        {endWhatsApp && (
          <div className="prescription-step__end">
            <img
              className="prescription-step__end__img"
              src={whatsApp}
              alt="Whats App"
            />
            <p className="prescription-step__end__text">
              Os produtos são destinados para o público masculino, assim é necessário que seu parceiro realize a consulta. Quando ele finalizar, por favor, nos avise no WhatsApp para associarmos à reserva do pedido, caso exista.
            </p>
            <a className="prescription-step__end__link"
              href="https://wa.me/5511942120797">
              Conversar no WhatsApp: (11)942120797
            </a>
            <a className="prescription-step__end__link"
              href="/">
              Voltar para home
            </a>
          </div>
        )}
      </>
      <div className="prescription-step__progress">
        <div className="prescription-step__progress__inner">
          <div className="prescription-step__progress__inner__bar">
            <div
              className="prescription-step__progress__inner__bar__progress"
              style={{
                backgroundColor: getPageColor(page, type),
                width: `${getProgressAmount(page, type)}%`,
              }}
            />
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen}>
        <div className="prescription-step__update-rg">
          <h1 className='prescription-step__update-rg__title'>{I18n.t('PAGES.HOME.PROFILE_REGISTER.FORM.UPDATE_RG.TITLE')}</h1>
          <p className="prescription-step__update-rg__description">{I18n.t('PAGES.HOME.PROFILE_REGISTER.FORM.UPDATE_RG.DESCRIPTION')}</p>
          <Row className="prescription-step__update-rg__form">
            <AdvancedInput
              type="text"
              label={I18n.t('PAGES.HOME.PROFILE_REGISTER.FORM.UPDATE_RG.RG')}
              value={rgMask(userNationalityDocument)}
              onChange={(e) => setUserNationalityDocument(e.target.value.toUpperCase())}
            />
            <AdvancedButton
              text={I18n.t('PAGES.HOME.PROFILE_REGISTER.FORM.UPDATE_RG.BUTTON')}
              onClick={onUpdateUser}
            >
            </AdvancedButton>
          </Row>
        </div>
      </Modal>
      {selectedAnswers?.map((question, questionIndex) => (
        <div
          className="prescription-step__single"
          key={questionIndex.toString()}
        >
          {question.answers.find((o) => !o.hidden) && (
            <div className="prescription-step__single__title">
              {question.message && (
                <p className="prescription-step__single__message">
                  <b>{I18n.t('COMPONENTS.PRESCRIPTION.ATTENTION')}</b>
                  {question.message}
                </p>
              )}
              {question.title && question.title}
              {question.haveTextBold && (
                <p>
                  {question.initialText} <b>{question.textBold}</b>{' '}
                  {question.finalText}
                </p>
              )}
            </div>
          )}

          <div
            className={`prescription-step__single__answers ${question.inline && 'prescription-step__single__answers--inline'
              }`}
          >
            {question.answers.map((answer, answerIndex) => (
              <div
                key={answerIndex}
                className={`${(answer.type === QuestionAnswerType.OPEN_TEXT || answer.type === QuestionAnswerType.ONLY_NUMBER) &&
                  'prescription-step__single__answers--full'
                  }`}
              >
                {answer.type === QuestionAnswerType.SINGLE_CHOICE &&
                  !answer.hidden && (
                  <div
                    className="prescription-step__single__answers__single prescription-step__single__answers__single--single-choice"
                    style={{
                      borderColor: isSelectedAnswer(
                        questionIndex,
                        answerIndex
                      )
                        ? getPageColor(page, type)
                        : '#7D7D7D',
                      boxShadow:
                          isSelectedAnswer(questionIndex, answerIndex) &&
                          `inset 0px 0px 0px 2px ${getPageColor(page, type)}`,
                      backgroundColor:
                          isSelectedAnswer(questionIndex, answerIndex) &&
                          LightenDarkenColor(getPageColor(page, type), 110),
                    }}
                    onClick={() => {
                      answerQuestion(
                        questionIndex,
                        answerIndex,
                        answer.value,
                        answer
                      );
                      handleClick();
                    }}
                  >
                    <div className="prescription-step__single__answers__single--single-choice__inner">
                      {answer.value}
                    </div>
                    {answer.icon && (
                      <div className="prescription-step__single__answers__single--single-choice__icon">
                        <img
                          className="prescription-step__single__answers__single--single-choice__icon__img"
                          src={answer.icon}
                          alt={answer.value}
                        />
                      </div>
                    )}
                  </div>
                )}

                {answer.type === QuestionAnswerType.MULTIPLE_CHOICE &&
                  !answer.hidden && (
                  <>
                    <div
                      className="prescription-step__multiple__answers__single prescription-step__single__answers__single--multiple-choice"
                      style={{
                        borderColor: isSelectedAnswer(
                          questionIndex,
                          answerIndex
                        )
                          ? getPageColor(page, type)
                          : '#7D7D7D',
                        boxShadow:
                            isSelectedAnswer(questionIndex, answerIndex) &&
                            `inset 0px 0px 0px 2px ${getPageColor(page, type)}`,
                        backgroundColor:
                            isSelectedAnswer(questionIndex, answerIndex) &&
                            LightenDarkenColor(getPageColor(page, type), 110),
                      }}
                      onClick={() => {
                        answerQuestion(
                          questionIndex,
                          answerIndex,
                          answer.value
                        );
                        handleClick();
                      }}
                    >
                      <div className="prescription-step__single__answers__single--multiple-choice__inner">
                        <div
                          className="prescription-step__single__answers__single--multiple-choice__inner__radio"
                          style={{
                            borderColor: isSelectedAnswer(
                              questionIndex,
                              answerIndex
                            )
                              ? getPageColor(page, type)
                              : '#7D7D7D',
                          }}
                        >
                          {isSelectedAnswer(questionIndex, answerIndex) && (
                            <div
                              className="prescription-step__single__answers__single--multiple-choice__inner__radio__inner"
                              style={{
                                backgroundColor: getPageColor(page, type),
                              }}
                            />
                          )}
                        </div>
                        <div
                          className="prescription-step__single__answers__single--multiple-choice__inner__value"
                          style={{
                            fontWeight:
                                isSelectedAnswer(questionIndex, answerIndex) &&
                                'bold',
                          }}
                        >
                          {answer.value}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {(answer.type === QuestionAnswerType.OPEN_TEXT || answer.type === QuestionAnswerType.ONLY_NUMBER) && !answer.hidden && (
                  <div className="prescription-step__single__answers__single prescription-step__single__answers__single--open-text">
                    <div className="prescription-step__single__answers__single--open-text__inner">
                      {answer.value && answer.value !== '' && (
                        <div
                          className={`prescription-step__single__answers__single--open-text__inner__title ${answerIndex === 0 &&
                            'prescription-step__single__answers__single--open-text__inner__title--first'
                            }`}
                        >
                          {answer.value}
                        </div>
                      )}
                      <textarea
                        style={{
                          borderColor: '#7D7D7D',
                          outline: 'none',
                          width: '100%',
                        }}
                        onChange={(e) => {
                          const value = e.target.value;

                          if (answer.type === QuestionAnswerType.ONLY_NUMBER) {
                            if (value === '' || /^\d*\.?\d*$/.test(value)) {
                              answerQuestion(questionIndex, answerIndex, value);
                            }
                          } else {
                            answerQuestion(questionIndex, answerIndex, value);
                          }
                        }}
                        className="prescription-step__single__answers__single--open-text__inner__textarea"
                        placeholder={
                          answer.placeholder || (answer.type === QuestionAnswerType.ONLY_NUMBER ? 'Digite um número' : 'Digite sua resposta aqui')
                        }
                        rows={3}
                        value={
                          (selectedAnswers &&
                            selectedAnswers.length > 0 &&
                            selectedAnswers[questionIndex].answers[answerIndex].userAnswer) ||
                          ''
                        }
                      />
                    </div>
                  </div>
                )}

                {answer.alertCard && isSelectedAnswer(questionIndex, answerIndex) &&
                (question.id !== 6 || showIMCLowAlert) && (
                  <AlertCard
                    title={answer.alertCard.title}
                    description={answer.alertCard.description}
                  />
                )}
              </div>
            ))}

            {question?.alertCard && (
              <AlertCard
                title={question.alertCard.title}
                description={question.alertCard.description}
              />
            )}

            {page === isLastPage &&
            questionIndex + 1 === selectedAnswers.length && (
              <>
                {(type === QuestionType.HAIR_LOSS || type === QuestionType.WL || type === QuestionType.MELATONINA) ? (
                  <PhotoUploader
                    type={type}
                    onFilesChange={handleFilesChange}
                    initialFiles={fileLists}
                    uploadConfig={uploadConfigs[type]}
                  />
                ) : (
                  <div className="prescription-step__single__answers__picture">
                    {(type === QuestionType.EJ || type === QuestionType.ED || type === QuestionType.BE) && !isHaveNitrate && (
                      <h3 className="prescription-step__single__answers__picture__title">
                        {I18n.t('COMPONENTS.PRESCRIPTION.FINISH')}
                      </h3>
                    )}
                    {(type === QuestionType.ED || type === QuestionType.BE) && isHaveNitrate && (
                      <div className="attention-container">
                        <img
                          src={IcAttention}
                          alt={I18n.t(
                            'COMPONENTS.CART.FORM.ATENTION.TITLE'
                          )}
                          className="attention-icon"
                        />
                        <h3 className="prescription-step__single__answers__picture__title">
                          {`${me && me.name}, `}{' '}
                          {I18n.t('PAGES.HOME.HOW_ARE_YOU')} <br />{' '}
                          {I18n.t('PAGES.HOME.MESSAGE_DEFAULT_NITRATE')}
                        </h3>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ))}
      <div
        className={`prescription-step__footer ${page === isLastPage && 'prescription-step__footer--end'
          }`}
        ref={ref}
      >
        {page === isLastPage ? (
          <>
            <div className="payment__box__aux">
              <div className="payment__box__aux__form">
                <WhiteButton
                  onClick={() => setDebounce(onSubmit)}
                  medicineColor={'#1D6EA3'}
                  label={isSubmitting ? 'Enviando dados...' : I18n.t('COMPONENTS.FINISH_MEDICAL_EVALUATION')}
                  full
                  dark
                  disabled={isSubmitting}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <button
              className="prescription-step__footer__button prescription-step__footer__button--back"
              type="button"
              onClick={() => history.goBack()}
            >
              <span className="prescription-step__footer__button__icon">
                <img
                  className="prescription-step__footer__button__icon__img prescription-step__footer__button__icon__img--back"
                  src={IcBack}
                  alt=""
                />
              </span>
            </button>

            <button
              className="prescription-step__footer__button"
              type="button"
              onClick={onSubmit}
            >
              <span className="prescription-step__footer__button__icon">
                <img
                  className="prescription-step__footer__button__icon__img"
                  src={IcNext}
                  alt=""
                />
              </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  me: state.auth.me,
  quizUserResponse: state.prescription.quizUserResponse,
  createdQuiz: state.quiz.quizUserResponse,
  base64: state.base64,
});

const mapDispatchToProps = (dispatch) => ({
  updateUser: (id, data, callback) =>
    dispatch(UserActions.updateUser(id, data, callback)),
  setQuizUserResponse: (payload) =>
    dispatch(PrescriptionActions.setQuizUserResponse(payload)),
  setQuizUserPayload: (payload) =>
    dispatch(PrescriptionActions.setQuizUserPayload(payload)),
  getUserPrescriptionByType: (type) =>
    dispatch(PrescriptionActions.getUserPrescriptionByType(type)),
  createQuiz: (quiz) => dispatch(QuizActions.createQuiz(quiz)),
  createMedicalAppointment: (data) =>
    dispatch(MedicalAppointmentActions.createMedicalAppointment(data)),
  createEvolution: (data) => dispatch(EvolutionActions.createEvolution(data)),
  uploadImageBase64: (photoDataBase64) =>
    dispatch(UtilsActions.uploadImageBase64(photoDataBase64)),
  saveImageBase64: (imageBase64) =>
    dispatch(UtilsActions.saveImageBase64(imageBase64)),
  createChatMessage: (data) => dispatch(ChatMessageActions.createChatMessage(data)),
  getMineMedicalAppointments: (params) =>
    dispatch(MedicalAppointmentActions.getMedicalAppointmentMine(params)),
  getTransactionMineDetails: (params) => dispatch(TransactionActions.getTransactionsMineDetails(params)),
  setPrescriptionFeedback: (type) => dispatch(PrescriptionActions.setPrescriptionFeedback(type)),
  getMe: () => dispatch(AuthActions.getMe()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrescriptionStep);
